import styled, {CSSProperties, css} from 'styled-components';

import {Tr as BaseTr} from '@edna/components';
import {mixins} from '@edna/components/styles';

type TListActionsProps = {
  hasShadow?: boolean;
  disabled?: boolean;
};

export const ListActions = styled.div<TListActionsProps>`
  position: sticky;
  top: 0;
  ${mixins.stack({justify: 'flex-start', align: 'center', size: '4', direction: 'ROW'})};
  ${({hasShadow, theme, disabled}) => css`
    z-index: ${theme.zIndex.header};
    padding: ${theme.spacing.s4} 0 ${theme.spacing.s4};
    background-color: ${theme.branding.backgrounds.primary};
    box-shadow: ${hasShadow ? theme.boxShadow.listHead : 'none'};
    pointer-events: ${disabled ? 'none' : 'auto'};
  `}
`;

export const ListActionsMain = styled.div`
  flex-grow: 1;
`;

type TListActionsItemProps = {
  flex?: CSSProperties['flex'];
};

export const ListActionsItem = styled.div<TListActionsItemProps>`
  flex: ${({flex}) => flex ?? '1 0 auto'};
`;

export const TableHead = styled(BaseTr)`
  position: sticky;
  top: 68px;
  min-height: 56px;
  border: none;
  ${({theme}) => css`
    background-color: ${theme.branding.backgrounds.primary};
    z-index: ${theme.zIndex.subHeader};
    box-shadow: ${theme.boxShadow.listHead};
    padding: ${theme.spacing.s1} 0;
  `}
`;

export const ListTotal = styled.div`
  ${mixins.f6};
  font-weight: 500;
  padding: ${({theme}) => `${theme.spacing.s2} 0 ${theme.spacing.s4}`};
`;

export const SkeletonList = styled.div`
  ${mixins.column}
  gap: 20px;
  margin-top: ${({theme}) => theme.spacing.s4};
`;
